import _ from "lodash";
import XlsxTemplate from "xlsx-template";
import fieldFormatter from "../../../react-table/helpers/fieldFormatter";
import reportDataExtenders from "./reportDataExtenders";
import reportDataUngroupers from "./reportDataUngroupers";

export const getColumnFields = (columns) => _.map(columns, "id");

export const replaceDotsWithDashes = (str) => str.replace(/\./g, "-");

export const mapColumnsToRowObject = (row, columns) =>
  _(columns)
    .filter((column) => row[column] !== undefined)
    .reduce(
      (acc, column) => ({
        ...acc,
        [replaceDotsWithDashes(column)]: row[column],
      }),
      {}
    );

export const prepareDataForExcel = (data, columns) =>
  _(data)
    .map((row) => mapColumnsToRowObject(row, columns))
    .value();

export const prepareDataForExcelWithoutColumn = (data) =>
  _(data)
    .map((row) => row)
    .value();

export const formatData = (data, columns) =>
  _.map(data, (row) =>
    _.reduce(
      columns,
      (acc, column) => {
        // Use excelFormatter if available, fallback to column.type for backwards compatibility
        const formatterName = column.excelFormatter || column.type;
        const formatFunction = formatterName
          ? fieldFormatter(formatterName)
          : null;
        console.log(`column_id: ${column.id}`);
        console.log(row[column.id]);
        console.log(formatterName)
        const value = row[column.id];
        return {
          ...acc,
          [column.id]: formatFunction ? formatFunction({ value }) : value,
        };
      },
      row
    )
  );

export const formatDataForDespatchPerformance = (data, columns) =>
  _.map(data, (row) =>
    _.reduce(
      columns,
      (acc, column) => {
        // Use excelFormatter if available, fallback to column.type
        const formatterName = column.excelFormatter || column.type;
        const formatFunction = formatterName
          ? fieldFormatter(formatterName)
          : null;
        let value = row[column.id];
        if (value === undefined) {
          value = "";
        }
        return {
          ...acc,
          [column.id]: formatFunction ? formatFunction({ value }) : value,
        };
      },
      row
    )
  );

export const formatDataForPredes = (data, columns) =>
  _.map(data, (row) =>
    _.reduce(
      columns,
      (acc, column) => {
        // Use excelFormatter if available, fallback to column.type
        const formatterName = column.excelFormatter || column.type;
        const formatFunction = formatterName
          ? fieldFormatter(formatterName)
          : null;
        let value = row[column.id];
        if (value === 0 || value === null || value === "0") {
          value = "";
        }
        return {
          ...acc,
          [column.id]: formatFunction ? formatFunction({ value }) : value,
        };
      },
      row
    )
  );

export const formatDataForResdesManagementEpg = (data, columns) =>
  _.map(data, (row) =>
    _.reduce(
      columns,
      (acc, column) => {
        // Use excelFormatter if available, fallback to column.type
        const formatterName = column.excelFormatter || column.type;
        const formatFunction = formatterName
          ? fieldFormatter(formatterName)
          : null;
        let value = row[column.id];
        if (value === 0) {
          value = 0;
        }
        return {
          ...acc,
          [column.id]: formatFunction ? formatFunction({ value }) : value,
        };
      },
      row
    )
  );

function ungroup(data, columns, reportName) {
  let result = data;
  if (reportDataUngroupers[reportName]) {
    result = reportDataUngroupers[reportName](columns, data);
  }
  return result;
}

function extend(data, columns, reportName) {
  let result = data;
  if (reportDataExtenders[reportName]) {
    result = reportDataExtenders[reportName](columns, data);
  }
  return result;
}

function mapReactTableDataToExcelData(data, columns, reportName, totalRow) {
  const ungroupedData = ungroup(data, columns, reportName);
  let formattedData = formatData(ungroupedData, columns);
  console.log("printing formatted date:")
  console.log(formattedData);
  if (
    reportName === "POST_TO_POST_DESPATCH_PERFORMANCE" ||
    reportName === "IMPC_TO_IMPC_DESPATCH_PERFORMANCE"
  ) {
    formattedData = formatDataForDespatchPerformance(ungroupedData, columns);
  }
  if (
    reportName === "PREDES_RESDES_DESPATCHES_DETAILS" ||
    "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY" ||
    "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS"
  ) {
    formattedData = formatDataForPredes(ungroupedData, columns);
  }
  if (reportName === "RESDES_MANAGEMENT_SUMMARY_EPG") {
    formattedData = formatDataForResdesManagementEpg(ungroupedData, columns);
  }
  let extendedData;
  if (
    reportName === "POST_TO_POST_DESPATCH_PERFORMANCE" ||
    reportName === "IMPC_TO_IMPC_DESPATCH_PERFORMANCE" ||
    reportName === "EPG_LINK_BY_LINK_REPORT_013"
  ) {
    console.log("if POST_TO_POST_DESPATCH_PERFORMANCE or IMPC_TO_IMPC_DESPATCH_PERFORMANCE or EPG_LINK_BY_LINK_REPORT_013")
    extendedData = extend(
      {
        rows: [
          totalRow,
          ...prepareDataForExcel(formattedData, getColumnFields(columns)),
        ],
        totalRow,
      },
      columns,
      reportName
    );
  } else {
    console.log("else")
    extendedData = extend(
      {
        rows: prepareDataForExcel(formattedData, getColumnFields(columns)),
        totalRow,
      },
      columns,
      reportName
    );
  }
  return extendedData;
}

function mapReactTableDataToExcelDataWithoutColumn(data, columns, reportName) {
  const ungroupedData = ungroup(data, columns, reportName);
  const formattedData = formatData(ungroupedData, columns);
  const extendedData = extend(
    {
      rows: prepareDataForExcelWithoutColumn(formattedData),
    },
    columns,
    reportName
  );

  return extendedData;
}

const csv = (value) => value.join(", ");
const csvDespatchType = (value) =>
  csv(
    (value || [])
      .filter((v) => v.mailSubClasses.length)
      .map((v) => v.mailSubClasses.map((msc) => v.mailCategoryCode + msc))
      .reduce((a, b) => a.concat(b), [])
  );
const csvTransportMode = (value) =>
  (value || [])
    .filter((v) => v.transportModes.length)
    .map((v) => `${v.legCode}: ${csv(v.transportModes)}`)
    .join(" - ");
const scValueMapper = {
  period: (value) =>
    value.from === value.to ? value.from : `${value.from} -> ${value.to}`,
  dateField: (value) =>
    value
      .toLowerCase()
      .split("_")
      .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(" "),
  direction: (value) => (value === "O" ? "Outbound" : "Inbound"),
  mailCategoriesWithSubClasses: csvDespatchType,
  originExchangeOffices: csv,
  destinationExchangeOffices: csv,
  originUnlocodes: csv,
  destinationUnlocodes: csv,
  originMailboxes: csv,
  destinationMailboxes: csv,
  legsWithTransportModes: csvTransportMode,
  carriers: csv,
  handlers: csv,
  excludeEtoes: (value) => value,
  spaceSeparatedItemIds: (value) => value,
  itemsMissingEvents: (value) => value.join(", "),
  itemsWithEvents: csv,
  spaceSeparatedSuffixes: (value) => value,
  filterOnDespatchTypes: (value) => value,
  filterOnImpcs: (value) => value,
  itemPrefixes: csv,
};
const scNameMapper = {
  period: "Period",
  dateField: "Date field",
  direction: "Direction",
  originExchangeOffices: "Origin location",
  destinationExchangeOffices: "Destination location",
  originUnlocodes: "Origin location",
  destinationUnlocodes: "Destination location",
  originMailboxes: "Origin location",
  destinationMailboxes: "Destination location",
  mailCategoriesWithSubClasses: "Despatch type",
  legsWithTransportModes: "Method",
  carriers: "Carrier",
  handlers: "Handler",
  requestMode: "Request Mode",
  excludeEtoes: "Excluded etoes",
  spaceSeparatedItemIds: "Space Separated Items ids",
  itemsMissingEvents: "Missing items",
  itemsWithEvents: "With items",
  spaceSeparatedSuffixes: "Space separated suffixes",
  filterOnDespatchTypes: "Filter on despatch types",
  filterOnImpcs: "Filter on Impcs",
  itemPrefixes: "Item prefixes",
};

export function populateExcelFile(
  templateFile,
  reportMetaData,
  data,
  columns,
  selectionCriteria,
  totalRow
) {
  let reportData;
  if (reportMetaData.reportCode === "ITEM_OVERVIEW_DETAILS_200") {
    // eslint-disable-next-line max-len
    reportData = mapReactTableDataToExcelDataWithoutColumn(
      data,
      columns,
      reportMetaData.reportCode
    );
  } else {
    reportData = mapReactTableDataToExcelData(
      data,
      columns,
      reportMetaData.reportCode,
      totalRow
    );
  }
  const template = new XlsxTemplate(templateFile);
  template.substitute("Report", reportData);

  if (selectionCriteria) {
    template.substitute("Selection Criteria", {
      reportName: reportMetaData.reportName,
      rows: Object.keys(selectionCriteria)
        .map((key) => ({
          name: scNameMapper[key],
          // eslint-disable-next-line no-nested-ternary
          value:
            scValueMapper[key] && selectionCriteria[key]
              ? scValueMapper[key](selectionCriteria[key])
              : typeof selectionCriteria[key] === "boolean"
              ? selectionCriteria[key].toString()
              : selectionCriteria[key],
        }))
        .filter((sc) => !!sc.value),
    });
  }

  return template.generate();
}
